import {fsa, fsaError, fsaPayload} from './helpers'

export const FETCH_TRANSACTIONS = 'receipt/fetch transactions'
/**
 * @param {Object} payload
 * @param {String} payload.eventId The event ID
 */
export const fetchTransactions = fsaPayload(FETCH_TRANSACTIONS)

export const FETCH_TRANSACTIONS_PENDING = 'receipt/fetch transactions pending'
export const fetchTransactionsPending = fsa(FETCH_TRANSACTIONS_PENDING)

export const FETCH_TRANSACTIONS_FAILURE = 'receipt/fetch transactions failure'
export const fetchTransactionsFailure = fsaError(FETCH_TRANSACTIONS_FAILURE)

export const FETCH_TRANSACTIONS_SUCCESS = 'receipt/fetch transactions success'
/**
 * @param {Object}  payload
 * @param {String}  payload.eventName    The name of the event the transactions are associated with
 * @param {Array}   payload.transactions The transactions associated with the user's event
 */
export const fetchTransactionsSuccess = fsaPayload(FETCH_TRANSACTIONS_SUCCESS)
